export const withDeviceIdParam = (urlString: string) => {
    if (typeof window === "undefined") return urlString;
    const deviceId = localStorage.getItem("user_uuid");
    if (!deviceId) return urlString;
    const url = new URL(urlString, window.location.href);
    if (!url.searchParams.get("deviceId")) {
        url.searchParams.set("deviceId", deviceId);
    }
    return url.toString();
};

